import { useState, useEffect, useRef } from "react";
import axios from "axios";

const API = process.env.REACT_APP_API || "https://www.vilaro.ro/api";
const card = { background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.08)" };

export default function Intelligence() {
  const [activeTab, setActiveTab] = useState("teme");
  const [accounts, setAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(() => { const v = sessionStorage.getItem('intel_account'); return v && v !== 'null' ? v : null; });
  const [pages, setPages] = useState([]);
  const [selectedPage, setSelectedPage] = useState(() => { const v = sessionStorage.getItem('intel_page'); return v && v !== 'null' ? v : null; });

  useEffect(() => {
    axios.get(`${API}/stats/accounts`).then(res => setAccounts(res.data.accounts || [])).catch(() => {});
    axios.get(`${API}/pages`).then(res => setPages(res.data.pages || [])).catch(() => {});
  }, []);

  const filteredPages = selectedAccount 
    ? pages.filter(p => String(p.account_id) === String(selectedAccount))
    : pages;

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-white">🕵️ Intelligence</h2>
        <p className="text-sm mt-0.5" style={{ color: "rgba(255,255,255,0.35)" }}>Analiză coordonare și teme de atac</p>
      </div>
      <div className="flex items-center justify-between mb-4 flex-wrap gap-3">
        <div className="flex gap-2 flex-wrap">
          {[
            { id: "teme", label: "🎯 Teme Atac" },
            { id: "coordonare", label: "⚔️ Atacuri Coordonate" },
            { id: "sustinatori", label: "👥 Susținători" },
            { id: "export", label: "📥 Export AI" },
          ].map(t => (
            <button key={t.id} onClick={() => setActiveTab(t.id)}
              className="px-4 py-2 rounded-xl text-sm font-medium transition-all"
              style={activeTab === t.id ? btnPrimary : btnGray}>
              {t.label}
            </button>
          ))}
        </div>
        <div className="flex gap-3 flex-wrap items-center">
          {/* Filtru cont */}
          <div className="flex rounded-xl overflow-hidden" style={{border:"1px solid rgba(255,255,255,0.08)"}}>
            <button onClick={() => { setSelectedAccount(null); setSelectedPage(null); sessionStorage.removeItem('intel_account'); sessionStorage.removeItem('intel_page'); }}
              className="px-3 py-2 text-xs font-medium transition-all"
              style={!selectedAccount ? btnPrimary : {background:"rgba(255,255,255,0.04)",color:"rgba(255,255,255,0.5)"}}>
              🌐 Toate
            </button>
            {accounts.map(acc => (
              <button key={acc.id} onClick={() => { setSelectedAccount(String(acc.id)); setSelectedPage(null); sessionStorage.setItem('intel_account', String(acc.id)); sessionStorage.removeItem('intel_page'); }}
                className="px-3 py-2 text-xs font-medium transition-all border-l"
                style={String(selectedAccount) === String(acc.id) ? btnPrimary : {background:"rgba(255,255,255,0.04)",color:"rgba(255,255,255,0.5)",borderColor:"rgba(255,255,255,0.08)"}}>
                {acc.name}
              </button>
            ))}
          </div>
          {/* Filtru pagina */}
          {filteredPages.length > 0 && (
            <select className="rounded-xl px-3 py-2 text-xs" 
              style={{background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.08)",color:"white",outline:"none"}}
              value={selectedPage || ""}
              onChange={e => { const v = e.target.value || null; setSelectedPage(v); if(v) sessionStorage.setItem('intel_page', v); else sessionStorage.removeItem('intel_page'); }}>
              <option value="" style={{color:"black"}}>Toate paginile</option>
              {filteredPages.map(p => (
                <option key={p.id} value={p.id} style={{color:"black"}}>{p.name}</option>
              ))}
            </select>
          )}
        </div>
      </div>
      {/* Ghid selectie */}
      {!selectedPage && (
        <div className="rounded-2xl p-6 mb-4" style={{background:"rgba(99,102,241,0.05)",border:"1px solid rgba(99,102,241,0.2)"}}>
          <div className="flex items-start gap-4">
            <div className="text-2xl">📋</div>
            <div>
              <p className="text-sm font-semibold text-white mb-2">Cum să folosești Intelligence:</p>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <span className="text-xs px-2 py-0.5 rounded-full font-bold" style={{background: !selectedAccount ? "rgba(239,68,68,0.2)" : "rgba(34,197,94,0.2)", color: !selectedAccount ? "#fca5a5" : "#86efac"}}>
                    {!selectedAccount ? "1" : "✓"}
                  </span>
                  <p className="text-xs" style={{color: !selectedAccount ? "white" : "rgba(255,255,255,0.4)"}}>
                    Selectează un <strong>cont Facebook</strong> din dreapta sus
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-xs px-2 py-0.5 rounded-full font-bold" style={{background: !selectedAccount ? "rgba(255,255,255,0.06)" : !selectedPage ? "rgba(239,68,68,0.2)" : "rgba(34,197,94,0.2)", color: !selectedAccount ? "rgba(255,255,255,0.3)" : !selectedPage ? "#fca5a5" : "#86efac"}}>
                    {!selectedPage ? "2" : "✓"}
                  </span>
                  <p className="text-xs" style={{color: !selectedAccount ? "rgba(255,255,255,0.3)" : !selectedPage ? "white" : "rgba(255,255,255,0.4)"}}>
                    Selectează o <strong>pagină</strong> din dropdown-ul de pagini
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-xs px-2 py-0.5 rounded-full font-bold" style={{background:"rgba(255,255,255,0.06)",color:"rgba(255,255,255,0.3)"}}>3</span>
                  <p className="text-xs" style={{color:"rgba(255,255,255,0.3)"}}>
                    Navighează între <strong>Teme Atac</strong> și <strong>Atacuri Coordonate</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {activeTab === "teme" && <ThemeAttack accountId={selectedAccount} pageId={selectedPage} />}
      {activeTab === "coordonare" && <Coordination accountId={selectedAccount} pageId={selectedPage} />}
      {activeTab === "sustinatori" && <SupportersAnalysis accountId={selectedAccount} pageId={selectedPage} />}
      {activeTab === "export" && <IntelligenceExport accountId={selectedAccount} pageId={selectedPage} />}
    </div>
  );
}
const btnPrimary = { background: "linear-gradient(135deg, #6366f1, #8b5cf6)", color: "white" };
const btnGray = { background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.08)", color: "rgba(255,255,255,0.7)" };
const btnGreen = { background: "rgba(34,197,94,0.15)", border: "1px solid rgba(34,197,94,0.3)", color: "#86efac" };
const btnRed = { background: "rgba(239,68,68,0.1)", border: "1px solid rgba(239,68,68,0.2)", color: "#fca5a5" };
const btnOrange = { background: "rgba(249,115,22,0.1)", border: "1px solid rgba(249,115,22,0.25)", color: "#fdba74" };

const classificationStyles = {
  sustinator: { background: "rgba(34,197,94,0.15)", color: "#86efac" },
  critic: { background: "rgba(234,179,8,0.15)", color: "#fde047" },
  troll: { background: "rgba(239,68,68,0.15)", color: "#fca5a5" },
  intrebare: { background: "rgba(99,102,241,0.15)", color: "#a5b4fc" },
  neutru: { background: "rgba(255,255,255,0.06)", color: "rgba(255,255,255,0.5)" },
};

// ============================================================
// TEME ATAC
// ============================================================
function ThemeAttack({ accountId, pageId }) {
  const [themesData, setThemesData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [analyzingThemes, setAnalyzingThemes] = useState(false);
  const [analyzeProgress, setAnalyzeProgress] = useState(null);
  const [counterNarrative, setCounterNarrative] = useState(null);
  const [generatingCounter, setGeneratingCounter] = useState(null);
  const [savingCounter, setSavingCounter] = useState(false);
  const [savedCounter, setSavedCounter] = useState(false);
  const [showResetConfirm, setShowResetConfirm] = useState(false);

  const fetchThemes = async () => {
    setLoading(true);
    try {
      const params = pageId ? `?page_id=${pageId}` : "";
      const res = await axios.get(`${API}/themes/results${params}`);
      setThemesData(res.data);
    } catch(e) { console.error(e); }
    setLoading(false);
  };

  useEffect(() => { if (pageId) fetchThemes(); else setThemesData(null); }, [pageId]);

  if (!pageId) return (
    <div className="text-center py-16" style={{color:"rgba(255,255,255,0.3)"}}>
      <p className="text-4xl mb-3">📄</p>
      <p className="text-sm">Selectează o pagină pentru a vedea temele de atac</p>
    </div>
  );

  return (
    <div>
      <div className="flex items-center justify-between mb-4 flex-wrap gap-3">
        <div>
          <p className="text-xs" style={{color:"rgba(255,255,255,0.35)"}}>
            {themesData?.analyzed || 0} comentarii analizate
            {themesData?.remaining > 0 && ` · ${themesData?.remaining} neanalizate`}
          </p>
        </div>
        <div className="flex gap-2">
          {!analyzingThemes && (
            <div className="flex gap-2 flex-wrap">
              {themesData?.remaining > 0 && (
                <button onClick={async () => {
                  setAnalyzingThemes(true);
                  const analyzeParams = pageId ? `?page_id=${pageId}` : "";
                  await axios.post(`${API}/themes/analyze${analyzeParams}`);
                  const poll = setInterval(async () => {
                    const s = await axios.get(`${API}/themes/analyze-status`);
                    setAnalyzeProgress(s.data);
                    if (s.data.finished) {
                      clearInterval(poll);
                      setAnalyzingThemes(false);
                      fetchThemes();
                    } else {
                      if (s.data.done > 0) {
                        setThemesData(prev => prev ? {...prev, analyzed: s.data.done} : prev);
                      }
                    }
                  }, 5000);
                }} className="px-3 py-1.5 rounded-xl text-xs font-medium"
                  title={themesData?.analyzed > 0 ? "Continuă analiza de unde a rămas — comentariile deja analizate sunt păstrate" : "Pornește analiza AI pentru identificarea temelor de atac"}
                  style={btnPrimary}>
                  {themesData?.analyzed > 0 ? `▶ Continuă (${themesData?.remaining} rămase)` : `🔍 Analizează ${themesData?.remaining} comentarii`}
                </button>
              )}
              {themesData?.analyzed > 0 && pageId && (
                <button onClick={() => setShowResetConfirm(true)}
                  className="px-3 py-1.5 rounded-xl text-xs font-medium"
                  title="Șterge toate temele analizate și reia analiza de la zero"
                  style={{background:"rgba(239,68,68,0.08)",border:"1px solid rgba(239,68,68,0.2)",color:"#fca5a5"}}>
                  ⏹ Reia de la 0
                </button>
              )}
            </div>
          )}
          {analyzingThemes && (
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full animate-pulse" style={{background:"#6366f1"}}></div>
              <span className="text-xs" style={{color:"rgba(255,255,255,0.5)"}}>
                🧠 Analizez {analyzeProgress?.total || 0} comentarii... (~30-60 secunde
              </span>
            </div>
          )}
          <button onClick={fetchThemes} title="Reîncarcă temele din baza de date" className="px-3 py-1.5 rounded-xl text-xs" style={btnGray}>🔄</button>
        </div>
      </div>

      {showResetConfirm && (
            <div className="fixed inset-0 flex items-center justify-center z-50 p-4" style={{background:"rgba(0,0,0,0.85)"}}>
              <div className="rounded-2xl p-6 w-full" style={{background:"rgba(15,15,26,1)",border:"1px solid rgba(239,68,68,0.3)",maxWidth:"400px"}}>
                <h3 className="text-base font-bold text-white mb-2">⏹ Reia analiza de la 0</h3>
                <p className="text-sm mb-5" style={{color:"rgba(255,255,255,0.5)"}}>Toate temele analizate vor fi șterse și comentariile marcate ca neanalizate. Ești sigur?</p>
                <div className="flex gap-2 justify-end">
                  <button onClick={() => setShowResetConfirm(false)}
                    className="px-4 py-2 rounded-xl text-xs" style={{background:"rgba(255,255,255,0.06)",color:"rgba(255,255,255,0.5)"}}>
                    Anulează
                  </button>
                  <button onClick={async () => {
                    await axios.post(`${API}/themes/reset-page?page_id=${pageId}`);
                    setShowResetConfirm(false);
                    fetchThemes();
                  }} className="px-4 py-2 rounded-xl text-xs font-medium"
                    style={{background:"rgba(239,68,68,0.2)",border:"1px solid rgba(239,68,68,0.3)",color:"#fca5a5"}}>
                    ⏹ Da, resetează
                  </button>
                </div>
              </div>
            </div>
          )}
      {loading && <div className="text-sm py-8 text-center" style={{color:"rgba(255,255,255,0.25)"}}>Se încarcă...</div>}

      {counterNarrative && (
        <div className="fixed inset-0 flex items-center justify-center z-50 p-4" style={{background:"rgba(0,0,0,0.85)"}}>
          <div className="rounded-2xl p-6 w-full flex flex-col" style={{background:"rgba(15,15,26,1)",border:"1px solid rgba(34,197,94,0.3)",maxWidth:"860px",maxHeight:"90vh",overflow:"auto"}}>
            <div className="flex items-center justify-between mb-4">
              <div>
                <h3 className="text-lg font-bold text-white">🛡️ Contra-narativă</h3>
                <p className="text-xs mt-0.5" style={{color:"rgba(255,255,255,0.4)"}}>{counterNarrative.theme}</p>
              </div>
              <div className="flex gap-2">
                {counterNarrative?.text && !savedCounter && (
                  <button onClick={async () => {
                    setSavingCounter(true);
                    try {
                      await axios.post(`${API}/themes/save-counter-narrative`, {
                        theme_name: counterNarrative.theme,
                        page_id: pageId,
                        counter_narrative: counterNarrative.text
                      });
                      setSavedCounter(true);
                      // Actualizam local themesData
                      setThemesData(prev => ({
                        ...prev,
                        themes: prev.themes.map(t => 
                          t.theme === counterNarrative.theme 
                            ? {...t, contra_narativa: counterNarrative.text}
                            : t
                        )
                      }));
                    } catch(e) { console.error(e); }
                    setSavingCounter(false);
                  }} disabled={savingCounter}
                    className="px-3 py-1.5 rounded-xl text-xs font-medium disabled:opacity-50"
                    style={{background:"rgba(34,197,94,0.15)",border:"1px solid rgba(34,197,94,0.3)",color:"#86efac"}}>
                    {savingCounter ? "Se salvează..." : "💾 Salvează"}
                  </button>
                )}
                {savedCounter && <span className="px-3 py-1.5 text-xs" style={{color:"#86efac"}}>✅ Salvat!</span>}
                <button onClick={() => { setCounterNarrative(null); setSavedCounter(false); }} className="px-3 py-1.5 rounded-xl text-xs" style={btnGray}>Închide</button>
              </div>
            </div>
            <div className="text-sm whitespace-pre-wrap" style={{color:"rgba(255,255,255,0.85)",lineHeight:"1.7"}}>
              {counterNarrative.text}
            </div>
          </div>
        </div>
      )}

      {/* Sinteza generala */}
      {themesData?.sinteza && (
        <div className="rounded-2xl p-4 mb-4" style={{background:"rgba(99,102,241,0.05)",border:"1px solid rgba(99,102,241,0.2)"}}>
          <p className="text-xs font-semibold mb-2" style={{color:"#a5b4fc"}}>📋 SINTEZĂ GENERALĂ</p>
          <p className="text-sm" style={{color:"rgba(255,255,255,0.7)",lineHeight:"1.6"}}>{themesData.sinteza}</p>
        </div>
      )}
      {themesData?.strategie && (
        <div className="rounded-2xl p-4 mb-4" style={{background:"rgba(34,197,94,0.05)",border:"1px solid rgba(34,197,94,0.2)"}}>
          <p className="text-xs font-semibold mb-2" style={{color:"#86efac"}}>🎯 STRATEGIE RECOMANDATĂ</p>
          <p className="text-sm" style={{color:"rgba(255,255,255,0.7)",lineHeight:"1.6"}}>{themesData.strategie}</p>
        </div>
      )}

      <div className="grid grid-cols-1 gap-3">
        {themesData?.themes?.map((theme, i) => (
          <div key={i} className="rounded-2xl p-4" style={{
            background: theme.fake_news ? "rgba(239,68,68,0.05)" : "rgba(255,255,255,0.03)",
            border: `1px solid ${theme.fake_news ? "rgba(239,68,68,0.3)" : theme.tone === "agresiv" ? "rgba(249,115,22,0.2)" : theme.tone === "dezinformare" ? "rgba(234,179,8,0.2)" : "rgba(255,255,255,0.08)"}`
          }}>
            <div className="flex items-start justify-between mb-2 flex-wrap gap-2">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-semibold text-sm text-white">{theme.theme}</span>
                {theme.fake_news && <span className="text-xs px-2 py-0.5 rounded-full font-bold" style={{background:"rgba(239,68,68,0.2)",color:"#fca5a5"}}>🚨 FAKE NEWS</span>}
                <span className="text-xs px-2 py-0.5 rounded-full" style={
                  theme.tone === "agresiv" ? {background:"rgba(249,115,22,0.15)",color:"#fdba74"} :
                  theme.tone === "dezinformare" ? {background:"rgba(234,179,8,0.15)",color:"#fde047"} :
                  theme.tone === "ironic" ? {background:"rgba(139,92,246,0.15)",color:"#c4b5fd"} :
                  {background:"rgba(99,102,241,0.15)",color:"#a5b4fc"}
                }>{theme.tone}</span>
              </div>
              <span className="text-sm font-bold" style={{color:"#fca5a5"}}>{theme.total_frequency} comentarii</span>
            </div>
            <div className="rounded-full h-1.5 mb-3" style={{background:"rgba(255,255,255,0.06)"}}>
              <div className="h-1.5 rounded-full" style={{
                width:`${Math.min(100,(theme.total_frequency/(themesData?.themes?.[0]?.total_frequency||1))*100)}%`,
                background: theme.fake_news ? "linear-gradient(135deg,#ef4444,#dc2626)" :
                            theme.tone === "agresiv" ? "linear-gradient(135deg,#f97316,#ea580c)" :
                            theme.tone === "dezinformare" ? "linear-gradient(135deg,#eab308,#ca8a04)" :
                            "linear-gradient(135deg,#6366f1,#8b5cf6)"
              }}></div>
            </div>
            {theme.descriere && <p className="text-xs mb-2" style={{color:"rgba(255,255,255,0.5)"}}>{theme.descriere}</p>}
            {theme.subteme?.length > 0 && (
              <div className="flex flex-wrap gap-1 mb-2">
                {theme.subteme.map((s,j) => (
                  <span key={j} className="text-xs px-2 py-0.5 rounded-full" style={{background:"rgba(255,255,255,0.05)",color:"rgba(255,255,255,0.35)"}}>{s}</span>
                ))}
              </div>
            )}
            {theme.examples?.length > 0 && (
              <div className="space-y-1 mb-3">
                {theme.examples.slice(0,3).map((ex,j) => (
                  <p key={j} className="text-xs italic" style={{color:"rgba(255,255,255,0.4)"}}>"{ex}"</p>
                ))}
              </div>
            )}
            <button onClick={async () => {
              if (theme.contra_narativa) {
                setCounterNarrative({theme: theme.theme, text: theme.contra_narativa});
                return;
              }
              setGeneratingCounter(theme.theme);
              try {
                const res = await axios.post(`${API}/themes/counter-narrative`, {
                  theme_name: theme.theme, examples: theme.examples, tone: theme.tone, fake_news: theme.fake_news, frequency: theme.total_frequency
                });
                setCounterNarrative({theme: theme.theme, text: res.data.counter_narrative});
              } catch(e) { console.error(e); }
              setGeneratingCounter(null);
            }} disabled={generatingCounter === theme.theme}
              className="px-3 py-1.5 rounded-xl text-xs font-medium disabled:opacity-50"
              style={btnGreen}>
              {generatingCounter === theme.theme ? "Se generează..." : theme.contra_narativa ? "🛡️ Vezi Contra-narativă" : "🛡️ Generează Contra-narativă"}
            </button>
            <button onClick={async () => {
              setGeneratingCounter(theme.theme + "_ai");
              try {
                const res = await axios.post(`${API}/themes/counter-narrative`, {
                  theme_name: theme.theme, examples: theme.examples, tone: theme.tone, fake_news: theme.fake_news, frequency: theme.total_frequency
                });
                setCounterNarrative({theme: theme.theme, text: res.data.counter_narrative});
              } catch(e) { console.error(e); }
              setGeneratingCounter(null);
            }} disabled={generatingCounter === theme.theme + "_ai"}
              className="px-2 py-1.5 rounded-xl text-xs disabled:opacity-50"
              title="Generează contra-narativă detaliată cu AI"
              style={{background:"rgba(99,102,241,0.1)",border:"1px solid rgba(99,102,241,0.2)",color:"#a5b4fc"}}>
              {generatingCounter === theme.theme + "_ai" ? "..." : "🤖 AI"}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

// ============================================================
// COORDONARE
// ============================================================
function Coordination({ accountId, pageId }) {
  const [coordData, setCoordData] = useState(null);
  const [coordLoading, setCoordLoading] = useState(false);
  const [coordTab, setCoordTab] = useState("summary");
  const [selectedCommenter, setSelectedCommenter] = useState(null);

  const fetchCoordination = async () => {
    setCoordLoading(true);
    let params = "";
    if (pageId) params = `?page_id=${pageId}`;
    else if (accountId) params = `?account_id=${accountId}`;
    try {
      const [summary, bursts, supporters, postsAttack] = await Promise.all([
        axios.get(`${API}/coordination/summary${params}`),
        axios.get(`${API}/coordination/bursts${params}${params ? "&" : "?"}min_users=3`),
        axios.get(`${API}/coordination/supporters${params}`),
        axios.get(`${API}/coordination/posts-attack${params}`),
      ]);
      setCoordData({
        summary: summary.data,
        bursts: bursts.data,
        supporters: supporters.data,
        postsAttack: postsAttack.data,
      });
    } catch(e) { console.error(e); }
    setCoordLoading(false);
  };

  useEffect(() => { if (pageId || accountId) fetchCoordination(); else setCoordData(null); }, [accountId, pageId]);

  if (!pageId && !accountId) return (
    <div className="text-center py-16" style={{color:"rgba(255,255,255,0.3)"}}>
      <p className="text-4xl mb-3">🕵️</p>
      <p className="text-sm">Selectează un cont sau o pagină pentru analiză</p>
    </div>
  );

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <p className="text-xs" style={{color:"rgba(255,255,255,0.35)"}}>Detectare comportament coordonat și conturi suspecte</p>
        <button onClick={fetchCoordination} className="px-3 py-1.5 rounded-xl text-xs" style={btnGray}>🔄 Reîncarcă</button>
      </div>

      <div className="flex gap-1 mb-5 p-1 rounded-xl flex-wrap" style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.06)"}}>
        {[

          {id:"summary", label:"🚫 Negativi"},
          {id:"bursts", label:"⚡ Valuri"},
          {id:"posts", label:"📄 Postări Atacate"},
        ].map(t => (
          <button key={t.id} onClick={() => setCoordTab(t.id)}
            className="flex-1 px-3 py-2 rounded-lg text-xs font-medium transition-all"
            style={coordTab === t.id ? btnPrimary : {color:"rgba(255,255,255,0.4)"}}>
            {t.label}
          </button>
        ))}
      </div>

      {coordLoading && <div className="text-sm py-8 text-center" style={{color:"rgba(255,255,255,0.3)"}}>Se analizează...</div>}

      {/* Negativi */}
      {!coordLoading && coordTab === "summary" && coordData && (
        <div className="space-y-3">
          {coordData.summary.suspicious_users?.length === 0 && (
            <div className="text-center py-12 text-sm" style={{color:"rgba(255,255,255,0.25)"}}>Niciun user suspect detectat</div>
          )}
          {coordData.summary.suspicious_users?.map((user, i) => (
            <div key={i} className="rounded-2xl p-4" style={{background:"rgba(255,255,255,0.03)",border:`1px solid ${user.behavior === 'agresiv' ? 'rgba(239,68,68,0.3)' : user.behavior === 'coordonat' ? 'rgba(234,179,8,0.3)' : 'rgba(255,255,255,0.08)'}`}}>
              <div className="flex items-start justify-between mb-2">
                <div className="flex items-center gap-2 flex-wrap">
                  <button className="font-semibold text-sm text-white hover:text-indigo-300"
                    onClick={() => setSelectedCommenter({id: user.from_id, name: user.from_name})}>
                    {user.from_name}
                  </button>
                  <span className="text-xs px-2 py-0.5 rounded-full" style={
                    user.behavior === 'agresiv' ? {background:"rgba(239,68,68,0.15)",color:"#fca5a5"} :
                    user.behavior === 'coordonat' ? {background:"rgba(234,179,8,0.15)",color:"#fde047"} :
                    {background:"rgba(255,255,255,0.06)",color:"rgba(255,255,255,0.4)"}
                  }>{user.behavior}</span>
                  {user.is_blocked
                    ? <span className="text-xs px-2 py-0.5 rounded-full" style={{background:"rgba(249,115,22,0.15)",color:"#fdba74"}}>🚫 blocat</span>
                    : <span className="text-xs px-2 py-0.5 rounded-full" style={{background:"rgba(34,197,94,0.08)",color:"rgba(134,239,172,0.6)"}}>● activ</span>
                  }
                </div>
                <span className="text-xs font-bold" style={{color: user.suspicion_score > 60 ? "#fca5a5" : user.suspicion_score > 30 ? "#fde047" : "#86efac"}}>
                  {user.suspicion_score}/100
                </span>
              </div>
              <div className="flex gap-4 flex-wrap">
                {[
                  {label:"Total", value:user.total, color:"white"},
                  {label:"Negative", value:user.negative, color:"#fca5a5"},
                  {label:"Pagini", value:user.pages_targeted, color:"#a5b4fc"},
                  {label:"Postări", value:user.posts_targeted, color:"#c4b5fd"},
                ].map((s,j) => (
                  <div key={j} className="text-center">
                    <p className="text-sm font-bold" style={{color:s.color}}>{s.value}</p>
                    <p className="text-xs" style={{color:"rgba(255,255,255,0.3)"}}>{s.label}</p>
                  </div>
                ))}
              </div>
              <div className="mt-2 rounded-full h-1" style={{background:"rgba(255,255,255,0.06)"}}>
                <div className="h-1 rounded-full" style={{width:`${user.suspicion_score}%`,background: user.suspicion_score > 60 ? "linear-gradient(135deg,#ef4444,#dc2626)" : user.suspicion_score > 30 ? "linear-gradient(135deg,#eab308,#ca8a04)" : "linear-gradient(135deg,#22c55e,#16a34a)"}}></div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Valuri */}
      {!coordLoading && coordTab === "bursts" && coordData && (
        <div className="space-y-3">
          {coordData.bursts.bursts?.length === 0 && (
            <div className="text-center py-12 text-sm" style={{color:"rgba(255,255,255,0.25)"}}>Niciun val de activitate detectat</div>
          )}
          {coordData.bursts.bursts?.map((burst, i) => (
            <div key={i} className="rounded-2xl p-4" style={{background:"rgba(255,255,255,0.03)",border:`1px solid ${burst.suspicion_score > 50 ? 'rgba(239,68,68,0.3)' : 'rgba(255,255,255,0.08)'}`}}>
              <div className="flex items-center justify-between mb-3">
                <span className="font-semibold text-sm text-white">🕐 {burst.time_bucket}:00</span>
                <span className="text-xs font-bold px-2 py-1 rounded-lg" style={{background: burst.suspicion_score > 50 ? "rgba(239,68,68,0.15)" : "rgba(234,179,8,0.15)", color: burst.suspicion_score > 50 ? "#fca5a5" : "#fde047"}}>Suspiciune: {burst.suspicion_score}/100</span>
              </div>
              <div className="flex gap-4 flex-wrap mb-3">
                {[
                  {label:"Useri", value:burst.unique_users, color:"white"},
                  {label:"Total", value:burst.total_comments, color:"#a5b4fc"},
                  {label:"Troli", value:burst.trolls, color:"#fca5a5"},
                  {label:"Critici", value:burst.critics, color:"#fde047"},
                  {label:"Susținători", value:burst.supporters, color:"#86efac"},
                ].map((s,j) => (
                  <div key={j} className="text-center">
                    <p className="text-sm font-bold" style={{color:s.color}}>{s.value}</p>
                    <p className="text-xs" style={{color:"rgba(255,255,255,0.3)"}}>{s.label}</p>
                  </div>
                ))}
              </div>
              {burst.user_names?.length > 0 && (
                <div className="flex flex-wrap gap-1">
                  {burst.user_names.slice(0,8).map((name,j) => {
                    const userStatus = burst.users_status?.[name];
                    return (
                      <span key={j} className="text-xs px-2 py-0.5 rounded-full"
                        style={userStatus?.is_blocked ? {background:"rgba(249,115,22,0.1)",color:"#fdba74"} : {background:"rgba(255,255,255,0.06)",color:"rgba(255,255,255,0.5)"}}>
                        {userStatus?.is_blocked ? "🚫" : "●"} {name}
                      </span>
                    );
                  })}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Postari Atacate */}
      {!coordLoading && coordTab === "posts" && coordData && (
        <PostsAttacked posts={coordData.postsAttack?.posts} />
      )}
    </div>
  );
}

function HoursDisplay({ hours }) {
  const [expandedHour, setExpandedHour] = useState(null);
  return (
    <div>
      <p className="text-xs font-semibold mb-2" style={{color:"rgba(255,255,255,0.3)"}}>ORE DE ACTIVITATE:</p>
      <div className="flex gap-1 flex-wrap">
        {hours.map((h, j) => {
          const negative = h.trolls + h.critics;
          const intensity = negative / Math.max(h.total, 1);
          const isExpanded = expandedHour === h.hour;
          return (
            <button key={j} onClick={() => setExpandedHour(isExpanded ? null : h.hour)}
              className="rounded-lg px-2 py-1.5 text-center transition-all"
              style={{minWidth:"52px", background: isExpanded ? "rgba(99,102,241,0.3)" : intensity > 0.6 ? "rgba(239,68,68,0.2)" : intensity > 0.3 ? "rgba(234,179,8,0.15)" : "rgba(34,197,94,0.1)", border:`1px solid ${isExpanded ? "rgba(99,102,241,0.6)" : intensity > 0.6 ? "rgba(239,68,68,0.4)" : intensity > 0.3 ? "rgba(234,179,8,0.3)" : "rgba(34,197,94,0.2)"}`}}>
              <p className="text-xs font-bold text-white">{h.hour}</p>
              <p className="text-xs" style={{color:"rgba(255,255,255,0.5)"}}>{h.total}</p>
              {negative > 0 && <p className="text-xs" style={{color:"#fca5a5"}}>🚫{negative}</p>}
            </button>
          );
        })}
      </div>
      {expandedHour && (() => {
        const hourData = hours.find(h => h.hour === expandedHour);
        if (!hourData?.quarters?.length) return null;
        return (
          <div className="mt-2 p-3 rounded-xl" style={{background:"rgba(99,102,241,0.06)",border:"1px solid rgba(99,102,241,0.2)"}}>
            <p className="text-xs font-semibold mb-2" style={{color:"#a5b4fc"}}>🕐 Detaliu {expandedHour}</p>
            <div className="flex gap-2 flex-wrap">
              {hourData.quarters.map((q, k) => {
                const negative = q.trolls + q.critics;
                const intensity = negative / Math.max(q.total, 1);
                return (
                  <div key={k} className="rounded-lg px-3 py-2 text-center"
                    style={{minWidth:"70px", background: intensity > 0.6 ? "rgba(239,68,68,0.2)" : intensity > 0.3 ? "rgba(234,179,8,0.15)" : "rgba(34,197,94,0.1)", border:`1px solid ${intensity > 0.6 ? "rgba(239,68,68,0.4)" : intensity > 0.3 ? "rgba(234,179,8,0.3)" : "rgba(34,197,94,0.2)"}`}}>
                    <p className="text-xs font-bold text-white">{q.label}</p>
                    <p className="text-sm font-bold text-white">{q.total}</p>
                    {negative > 0 && <p className="text-xs" style={{color:"#fca5a5"}}>🚫 {negative}</p>}
                    <p className="text-xs" style={{color:"rgba(255,255,255,0.3)"}}>{q.unique_users} useri</p>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })()}
    </div>
  );
}

function PostsAttacked({ posts }) {
  if (!posts?.length) return <div className="text-center py-12 text-sm" style={{color:"rgba(255,255,255,0.25)"}}>Nicio postare atacată</div>;
  return (
    <div className="space-y-4">
      {posts.map((post, i) => (
        <div key={i} className="rounded-2xl p-4" style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(239,68,68,0.2)"}}>
          <div className="mb-3">
            <span className="text-xs font-medium" style={{color:"#a5b4fc"}}>{post.page_name}</span>
            <p className="text-sm mt-1" style={{color:"rgba(255,255,255,0.7)"}}>{post.post_message_short}...</p>
          </div>
          <div className="flex gap-4 flex-wrap mb-4">
            {[
              {label:"Total", value:post.total_comments, color:"white"},
              {label:"Troli", value:post.trolls, color:"#fca5a5"},
              {label:"Critici", value:post.critics, color:"#fde047"},
              {label:"Susținători", value:post.supporters, color:"#86efac"},
              {label:"Useri unici", value:post.unique_users, color:"#a5b4fc"},
            ].map((s,j) => (
              <div key={j} className="text-center">
                <p className="text-sm font-bold" style={{color:s.color}}>{s.value}</p>
                <p className="text-xs" style={{color:"rgba(255,255,255,0.3)"}}>{s.label}</p>
              </div>
            ))}
          </div>
          {post.hours?.length > 0 && <HoursDisplay hours={post.hours} />}
        </div>
      ))}
    </div>
  );
}

// ============================================================
// SUSTINATORI
// ============================================================
function SupportersAnalysis({ accountId, pageId }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedWeek, setSelectedWeek] = useState(null);
  const [managersData, setManagersData] = useState(null);
  const [expandedManager, setExpandedManager] = useState(null);
  const [exportOpen, setExportOpen] = useState(false);

  const handleExport = async (scope, format = "excel") => {
    try {
      const params = new URLSearchParams({ scope });
      if (pageId) params.append("page_id", pageId);
      else if (accountId) params.append("account_id", accountId);
      const res = await axios.get(`${API}/supporters/export/${format}?${params}`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      const ext = format === "pdf" ? "pdf" : "xlsx";
      const fname = scope === "all" ? `sustinatori_complet.${ext}` : `sustinatori_${scope}.${ext}`;
      a.download = fname;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) { console.error(e); alert("Eroare la export"); }
  };

  const fetchData = async () => {
    setLoading(true);
    setData(null);
    setSelectedWeek(null);
    try {
      const params = pageId ? `?page_id=${pageId}` : accountId ? `?account_id=${accountId}` : "";
      const res = await axios.get(`${API}/supporters/activity${params}`);
      setData(res.data);
      if (res.data.weeks?.length > 0) {
        setSelectedWeek(res.data.weeks[0].week_key);
      }
    } catch(e) { console.error(e); }
    setLoading(false);
  };

  const fetchManagers = async () => {
    try {
      const params = pageId ? `?page_id=${pageId}` : accountId ? `?account_id=${accountId}` : "";
      const res = await axios.get(`${API}/supporters/by-manager${params}`);
      setManagersData(res.data);
    } catch(e) { console.error(e); }
  };

  useEffect(() => { fetchData(); fetchManagers(); }, [accountId, pageId]);

  const days = ['Dum','Lun','Mar','Mie','Joi','Vin','Sam'];
  const dayNames = ['Duminică','Luni','Marți','Miercuri','Joi','Vineri','Sâmbătă'];

  if (loading) return <div className="text-center py-12 text-sm" style={{color:"rgba(255,255,255,0.3)"}}>Se încarcă...</div>;

  return (
    <div className="space-y-6">
      <div className="flex justify-end gap-2 items-center">
        {/* Export dropdown */}
        {managersData?.managers?.length > 0 && (
          <div className="relative">
            <button onClick={() => setExportOpen(!exportOpen)} className="px-3 py-1.5 rounded-xl text-xs font-medium" style={btnPrimary}>
              📤 Export ▾
            </button>
            {exportOpen && (
              <div className="absolute right-0 mt-1 rounded-xl py-1 z-10 min-w-64" style={{background:"rgba(20,20,30,0.98)", border:"1px solid rgba(255,255,255,0.1)", boxShadow:"0 8px 24px rgba(0,0,0,0.4)"}}>
                <div className="text-xs px-3 pt-2 pb-1 font-semibold" style={{color:"rgba(255,255,255,0.6)"}}>Toți coordonatorii:</div>
                <button onClick={() => { handleExport("all", "pdf"); setExportOpen(false); }}
                  className="w-full text-left px-3 py-2 text-xs hover:bg-white/5" style={{color:"white"}}>
                  📄 PDF (cu grafice)
                </button>
                <button onClick={() => { handleExport("all", "excel"); setExportOpen(false); }}
                  className="w-full text-left px-3 py-2 text-xs hover:bg-white/5" style={{color:"white"}}>
                  📊 Excel
                </button>
                <div className="text-xs px-3 pt-2 pb-1 font-semibold border-t mt-1" style={{color:"rgba(255,255,255,0.6)",borderColor:"rgba(255,255,255,0.05)"}}>Per coordonator:</div>
                {managersData.managers.filter(m => m.manager !== "(fără)").map(m => (
                  <div key={m.manager} className="flex items-center justify-between px-3 py-1 hover:bg-white/5">
                    <span className="text-xs" style={{color:"rgba(255,255,255,0.8)"}}>{m.manager}</span>
                    <div className="flex gap-1">
                      <button onClick={() => { handleExport(m.manager, "pdf"); setExportOpen(false); }}
                        className="px-2 py-0.5 rounded text-xs" style={{background:"rgba(99,102,241,0.2)",color:"#a5b4fc"}}>PDF</button>
                      <button onClick={() => { handleExport(m.manager, "excel"); setExportOpen(false); }}
                        className="px-2 py-0.5 rounded text-xs" style={{background:"rgba(34,197,94,0.2)",color:"#86efac"}}>Excel</button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
        <button onClick={() => { fetchData(); fetchManagers(); }} className="px-3 py-1.5 rounded-xl text-xs" style={btnGray}>🔄 Reîncarcă</button>
      </div>

      {/* Secțiunea PER COORDONATOR */}
      {managersData?.managers?.length > 0 && (
        <div className="rounded-2xl p-4" style={card}>
          <div className="flex items-center justify-between mb-3">
            <p className="text-sm font-semibold text-white">👨‍💼 Activitate per Coordonator</p>
            <span className="text-xs" style={{color:"rgba(255,255,255,0.3)"}}>Click pe rând pentru detalii</span>
          </div>

          {/* Bar chart comparație 7 zile */}
          <div className="mb-4">
            <p className="text-xs mb-2" style={{color:"rgba(255,255,255,0.5)"}}>Comentarii ultimele 7 zile</p>
            <div className="space-y-1.5">
              {(() => {
                const max = Math.max(...managersData.managers.map(m => m.comentarii_7d || 0), 1);
                return managersData.managers.map(m => (
                  <div key={m.manager} className="flex items-center gap-2">
                    <span className="text-xs font-medium w-20 shrink-0" style={{color:"rgba(255,255,255,0.7)"}}>{m.manager}</span>
                    <div className="flex-1 rounded-full h-5 relative" style={{background:"rgba(255,255,255,0.04)"}}>
                      <div className="h-5 rounded-full flex items-center px-2" style={{
                        width: `${Math.max((m.comentarii_7d/max)*100, m.comentarii_7d > 0 ? 4 : 0)}%`,
                        background: m.manager === '(fără)' ? 'rgba(156,163,175,0.4)' : 'linear-gradient(90deg,#6366f1,#8b5cf6)',
                        minWidth: m.comentarii_7d > 0 ? '50px' : '0'
                      }}>
                        <span className="text-xs font-bold text-white">{m.comentarii_7d}</span>
                      </div>
                    </div>
                  </div>
                ));
              })()}
            </div>
          </div>

          {/* Timeline 14 zile per coordonator */}
          {managersData?.managers && (() => {
            // Construim 14 zile
            const today = new Date();
            const days14 = [];
            for (let i = 13; i >= 0; i--) {
              const d = new Date(today);
              d.setDate(d.getDate() - i);
              days14.push(d.toISOString().substring(0,10));
            }
            // Pentru fiecare manager, valori pe zi
            const colors = {'Damian':'#fca5a5','Oana':'#86efac','Cristi':'#a5b4fc','Roby':'#fde047','Marius':'#c4b5fd','(fără)':'rgba(156,163,175,0.6)'};
            const series = managersData.managers.map(m => ({
              name: m.manager,
              color: colors[m.manager] || '#c4b5fd',
              data: days14.map(zi => {
                const d = (m.daily || []).find(x => x.zi === zi);
                return d ? d.cnt : 0;
              })
            }));
            const maxVal = Math.max(...series.flatMap(s => s.data), 1);
            const w = 700, h = 120, pad = 25;
            const xStep = (w - 2*pad) / (days14.length - 1);
            return (
              <div className="mb-4 rounded-xl p-3" style={{background:"rgba(255,255,255,0.02)"}}>
                <div className="flex items-center justify-between mb-2 flex-wrap gap-2">
                  <p className="text-xs font-semibold" style={{color:"rgba(255,255,255,0.6)"}}>📈 Timeline 14 zile</p>
                  <div className="flex gap-3 flex-wrap">
                    {series.map(s => (
                      <span key={s.name} className="flex items-center gap-1 text-xs">
                        <span className="inline-block w-3 h-0.5" style={{background:s.color}}></span>
                        <span style={{color:"rgba(255,255,255,0.7)"}}>{s.name}</span>
                      </span>
                    ))}
                  </div>
                </div>
                <svg viewBox={`0 0 ${w} ${h}`} className="w-full" style={{maxHeight:"180px"}}>
                  {/* Grid lines */}
                  {[0, 0.25, 0.5, 0.75, 1].map((p, i) => (
                    <line key={i} x1={pad} y1={pad + (h-2*pad)*(1-p)} x2={w-pad} y2={pad + (h-2*pad)*(1-p)}
                      stroke="rgba(255,255,255,0.05)" strokeWidth="1" />
                  ))}
                  {/* Y axis labels */}
                  {[0, 0.5, 1].map((p, i) => (
                    <text key={i} x={pad-3} y={pad + (h-2*pad)*(1-p) + 3} fontSize="8" fill="rgba(255,255,255,0.3)" textAnchor="end">
                      {Math.round(maxVal*p)}
                    </text>
                  ))}
                  {/* X axis labels */}
                  {days14.map((d, i) => i % 2 === 0 && (
                    <text key={i} x={pad + i*xStep} y={h-5} fontSize="8" fill="rgba(255,255,255,0.3)" textAnchor="middle">
                      {d.substring(5)}
                    </text>
                  ))}
                  {/* Series */}
                  {series.map(s => {
                    const points = s.data.map((v, i) => `${pad + i*xStep},${pad + (h-2*pad)*(1 - v/maxVal)}`).join(' ');
                    return (
                      <g key={s.name}>
                        <polyline points={points} fill="none" stroke={s.color} strokeWidth="1.5" />
                        {s.data.map((v, i) => v > 0 && (
                          <circle key={i} cx={pad + i*xStep} cy={pad + (h-2*pad)*(1 - v/maxVal)} r="2" fill={s.color}>
                            <title>{s.name} {days14[i]}: {v}</title>
                          </circle>
                        ))}
                      </g>
                    );
                  })}
                </svg>
              </div>
            );
          })()}

          {/* Tabel */}
          <div className="overflow-x-auto">
            <table className="w-full text-xs">
              <thead>
                <tr style={{color:"rgba(255,255,255,0.4)"}}>
                  <th className="text-left py-2 px-2">Coordonator</th>
                  <th className="text-right py-2 px-2">Susținători</th>
                  <th className="text-right py-2 px-2">Azi</th>
                  <th className="text-right py-2 px-2">Cmt 7d</th>
                  <th className="text-right py-2 px-2">Cmt 30d</th>
                  <th className="text-left py-2 px-2">Top susținător</th>
                  <th className="text-left py-2 px-2">Ultima activitate</th>
                </tr>
              </thead>
              <tbody>
                {managersData.managers.map(m => (
                  <>
                    <tr key={m.manager} className="cursor-pointer hover:bg-white/5" 
                      onClick={() => setExpandedManager(expandedManager === m.manager ? null : m.manager)}
                      style={{borderTop:"1px solid rgba(255,255,255,0.05)"}}>
                      <td className="py-2 px-2 font-semibold text-white">
                        {expandedManager === m.manager ? '▼' : '▶'} {m.manager}
                      </td>
                      <td className="text-right py-2 px-2" style={{color:"#a5b4fc"}}>{m.nr_sustinatori}</td>
                      <td className="text-right py-2 px-2 font-bold" style={{color:m.comentarii_azi>0?"#fde047":"rgba(255,255,255,0.3)"}}>{m.comentarii_azi||0}</td>
                      <td className="text-right py-2 px-2 font-bold" style={{color:m.comentarii_7d>0?"#86efac":"rgba(255,255,255,0.3)"}}>{m.comentarii_7d}</td>
                      <td className="text-right py-2 px-2" style={{color:"rgba(255,255,255,0.5)"}}>{m.comentarii_30d}</td>
                      <td className="py-2 px-2" style={{color:"rgba(255,255,255,0.7)"}}>
                        {m.top_sustinator ? `${m.top_sustinator} (${m.top_count})` : '-'}
                      </td>
                      <td className="py-2 px-2" style={{color:"rgba(255,255,255,0.4)"}}>
                        {m.ultima_activitate ? new Date(m.ultima_activitate.replace(' ', 'T') + 'Z').toLocaleString('ro-RO', {dateStyle:'short', timeStyle:'short'}) : '-'}
                      </td>
                    </tr>
                    {expandedManager === m.manager && m.supporters?.length > 0 && (
                      <tr style={{background:"rgba(99,102,241,0.04)"}}>
                        <td colSpan="7" className="p-3">
                          <div className="grid gap-1 items-center" style={{gridTemplateColumns:"2fr 1.4fr 0.6fr 0.6fr 0.6fr 0.7fr 1.2fr"}}>
                            <div className="text-xs font-semibold" style={{color:"rgba(255,255,255,0.6)"}}>Susținător</div>
                            <div className="text-xs font-semibold" style={{color:"rgba(255,255,255,0.6)"}}>Activitate 7 zile</div>
                            <div className="text-xs font-semibold text-right" style={{color:"rgba(255,255,255,0.6)"}}>Azi</div>
                            <div className="text-xs font-semibold text-right" style={{color:"rgba(255,255,255,0.6)"}}>7d</div>
                            <div className="text-xs font-semibold text-right" style={{color:"rgba(255,255,255,0.6)"}}>30d</div>
                            <div className="text-xs font-semibold text-right" style={{color:"rgba(255,255,255,0.6)"}}>Total</div>
                            <div className="text-xs font-semibold" style={{color:"rgba(255,255,255,0.6)"}}>Ultima</div>
                            {m.supporters.map(s => {
                              // Construim sparkline: ultimele 7 zile
                              const today = new Date();
                              const days7 = [];
                              for (let i = 6; i >= 0; i--) {
                                const d = new Date(today);
                                d.setDate(d.getDate() - i);
                                const key = d.toISOString().substring(0, 10);
                                const found = (s.spark || []).find(sp => sp.zi === key);
                                days7.push({zi: key, cnt: found ? found.cnt : 0, label: d.toLocaleDateString('ro-RO', {weekday:'short'})});
                              }
                              const maxSpark = Math.max(...days7.map(d => d.cnt), 1);
                              return (
                                <>
                                  <div key={`n-${s.from_id}`} className="text-xs py-1" style={{color:"white"}}>{s.from_name}</div>
                                  <div key={`sp-${s.from_id}`} className="flex items-end gap-0.5 h-6">
                                    {days7.map((d, idx) => (
                                      <div key={idx} className="flex-1 rounded-sm" title={`${d.label}: ${d.cnt}`}
                                        style={{
                                          height: d.cnt > 0 ? `${Math.max((d.cnt/maxSpark)*100, 15)}%` : '6%',
                                          background: d.cnt > 0 ? '#86efac' : 'rgba(255,255,255,0.08)',
                                          minWidth: '4px'
                                        }} />
                                    ))}
                                  </div>
                                  <div key={`a-${s.from_id}`} className="text-xs py-1 text-right font-bold" style={{color:s.cmt_azi>0?"#fde047":"rgba(255,255,255,0.3)"}}>{s.cmt_azi||0}</div>
                                  <div key={`7-${s.from_id}`} className="text-xs py-1 text-right font-bold" style={{color:s.cmt_7d>0?"#86efac":"rgba(255,255,255,0.3)"}}>{s.cmt_7d}</div>
                                  <div key={`30-${s.from_id}`} className="text-xs py-1 text-right" style={{color:"rgba(255,255,255,0.5)"}}>{s.cmt_30d}</div>
                                  <div key={`t-${s.from_id}`} className="text-xs py-1 text-right" style={{color:"rgba(255,255,255,0.4)"}}>{s.total_comentarii}</div>
                                  <div key={`l-${s.from_id}`} className="text-xs py-1" style={{color:"rgba(255,255,255,0.4)"}}>
                                    {s.last_seen ? new Date(s.last_seen.replace(' ', 'T') + 'Z').toLocaleString('ro-RO', {dateStyle:'short'}) : '-'}
                                  </div>
                                </>
                              );
                            })}
                          </div>
                        </td>
                      </tr>
                    )}
                  </>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Heatmap activitate */}
      <div className="rounded-2xl p-4" style={card}>
        <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
          <p className="text-sm font-semibold text-white">🗓️ Activitate Susținători pe Săptămână</p>
          {data?.weeks?.length > 0 && (
            <div className="flex items-center gap-3">
              {(() => {
                const weekData = data.weeks.find(w => w.week_key === selectedWeek);
                if (!weekData) return null;
                const weekDates = [];
                const start = new Date(weekData.week_start);
                for (let di = 0; di < 7; di++) {
                  const d = new Date(start);
                  d.setDate(d.getDate() + di);
                  weekDates.push(d.toISOString().substring(0,10));
                }
                const weekPoints = data.heatmap?.filter(h => weekDates.includes(h.date)) || [];
                const total = weekPoints.reduce((s,h) => s + h.total, 0) || 0;
                return (
                  <div className="flex gap-3">
                    <span className="text-xs font-bold" style={{color:"#a5b4fc"}}>{weekData.total_comentarii || total} comentarii</span>
                    <span className="text-xs font-bold" style={{color:"#86efac"}}>{weekData.sustinatori_activi} susținători activi</span>
                  </div>
                );
              })()}
              <select className="rounded-xl px-3 py-1.5 text-xs"
                style={{background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.1)",color:"white",outline:"none"}}
                value={selectedWeek || ""}
                onChange={e => setSelectedWeek(e.target.value)}>
                {data.weeks.map(w => (
                  <option key={w.week_key} value={w.week_key} style={{color:"black"}}>
                    {w.week_start} — {w.week_end}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
        <div className="overflow-x-auto">
          <div className="grid gap-1" style={{gridTemplateColumns: "100px repeat(24, 1fr)", minWidth: "700px"}}>
            <div></div>
            {Array.from({length:24}, (_,i) => (
              <div key={i} className="text-center" style={{color:"rgba(255,255,255,0.3)",fontSize:"9px"}}>{i}:00</div>
            ))}
            {days.map((day, di) => {
              // Gasim data exacta pentru aceasta zi in saptamana selectata
              const weekPoints = data?.heatmap?.filter(h => {
                if (!selectedWeek) return parseInt(h.day_of_week) === di;
                const hWeek = h.date ? h.date.substring(0,4) + '-' + String(Math.ceil(new Date(h.date).getDate() / 7)).padStart(2,'0') : '';
                return parseInt(h.day_of_week) === di && h.date?.startsWith(selectedWeek?.substring(0,4));
              });
              
              // Gasim data exacta din saptamana selectata
              const weekData = data?.weeks?.find(w => w.week_key === selectedWeek);
              const dayDate = weekData ? (() => {
                const start = new Date(weekData.week_start);
                start.setDate(start.getDate() + di);
                return start.toLocaleDateString('ro-RO', {day:'2-digit', month:'2-digit'});
              })() : '';

              return (
                <>
                  <div key={`d${di}`} className="text-xs flex flex-col justify-center pr-2" style={{color:"rgba(255,255,255,0.6)"}}>
                    <span>{day}</span>
                    {dayDate && <span style={{color:"rgba(255,255,255,0.35)",fontSize:"9px"}}>{dayDate}</span>}
                  </div>
                  {Array.from({length:24}, (_,hi) => {
                    const filtered = data?.heatmap?.filter(h => {
                      if (!selectedWeek) return parseInt(h.day_of_week) === di && parseInt(h.hour) === hi;
                      const w = data.weeks?.find(ww => ww.week_key === selectedWeek);
                      if (!w) return false;
                      const start = new Date(w.week_start);
                      start.setDate(start.getDate() + di);
                      const dateStr = start.toISOString().substring(0,10);
                      return h.date === dateStr && parseInt(h.hour) === hi;
                    });
                    const val = filtered?.reduce((s,h) => s + h.total, 0) || 0;
                    const maxVal = Math.max(...(data?.heatmap?.map(h => h.total) || [1]));
                    const intensity = val / maxVal;
                    return (
                      <div key={`${di}-${hi}`} title={`${dayNames[di]} ${hi}:00 — ${val} comentarii`}
                        className="rounded" style={{
                          height:"28px",
                          background: val === 0 ? "rgba(255,255,255,0.04)" :
                            intensity > 0.7 ? "rgba(99,102,241,1)" :
                            intensity > 0.4 ? "rgba(99,102,241,0.7)" :
                            intensity > 0.1 ? "rgba(99,102,241,0.4)" :
                            "rgba(99,102,241,0.2)",
                          border: val > 0 ? "1px solid rgba(99,102,241,0.3)" : "none"
                        }}>
                        {val > 0 && (
                          <span style={{fontSize:"9px",color:"white",display:"flex",alignItems:"center",justifyContent:"center",height:"100%"}}>{val}</span>
                        )}
                      </div>
                    );
                  })}
                </>
              );
            })}
          </div>
        </div>
      </div>

      {/* Top postari mobilizatoare */}
      <div className="rounded-2xl p-4" style={card}>
        <p className="text-sm font-semibold text-white mb-3">🔥 Top Postări care Mobilizează Susținătorii</p>
        <div className="space-y-3">
          {data?.top_posts?.map((post, i) => (
            <div key={i} className="rounded-xl p-3" style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.06)"}}>
              <div className="flex items-start justify-between gap-2 mb-1">
                <p className="text-xs text-white">{post.message_short}...</p>
                <span className="text-xs font-bold shrink-0" style={{color:"#a5b4fc"}}>{post.sustinatori_unici} susținători</span>
              </div>
              <div className="flex gap-3 flex-wrap">
                <span className="text-xs" style={{color:"rgba(255,255,255,0.35)"}}>💬 {post.total_comentarii} comentarii</span>
                {post.minute_pana_la_primul !== null && (
                  <span className="text-xs" style={{color:"rgba(255,255,255,0.35)"}}>⚡ primul după {Math.round(post.minute_pana_la_primul)} min</span>
                )}
                <span className="text-xs" style={{color:"rgba(255,255,255,0.35)"}}>📅 {post.created_time?.substring(0,10)}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Cine comenteaza primul */}
      <div className="rounded-2xl p-4" style={card}>
        <p className="text-sm font-semibold text-white mb-3">⚡ Cine Comentează Primul</p>
        <div className="space-y-2">
          {data?.first_commenters?.map((u, i) => (
            <div key={i} className="flex items-center justify-between rounded-xl px-3 py-2" style={{background:"rgba(255,255,255,0.03)"}}>
              <span className="text-sm text-white">{u.from_name}</span>
              <div className="flex gap-4">
                <div className="text-center">
                  <p className="text-sm font-bold" style={{color:"#fde047"}}>{u.de_cate_ori_primul}</p>
                  <p className="text-xs" style={{color:"rgba(255,255,255,0.3)"}}>de primul</p>
                </div>
                <div className="text-center">
                  <p className="text-sm font-bold" style={{color:"#a5b4fc"}}>{Math.round(u.minute_mediu || 0)} min</p>
                  <p className="text-xs" style={{color:"rgba(255,255,255,0.3)"}}>timp mediu</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Consistenta */}
      <div className="rounded-2xl p-4" style={card}>
        <p className="text-sm font-semibold text-white mb-1">📊 Consistența Susținătorilor</p>
        <p className="text-xs mb-3" style={{color:"rgba(255,255,255,0.35)"}}>Din {data?.total_posts} postări totale</p>
        <div className="space-y-2">
          {data?.consistency?.map((u, i) => {
            const pct = data.total_posts > 0 ? Math.round((u.postari_comentate / data.total_posts) * 100) : 0;
            return (
              <div key={i} className="rounded-xl p-3" style={{background:"rgba(255,255,255,0.03)"}}>
                <div className="flex items-center justify-between mb-1">
                  <span className="text-sm text-white">{u.from_name}</span>
                  <div className="flex gap-3">
                    <span className="text-xs font-bold" style={{color:"#86efac"}}>{u.postari_comentate} postări</span>
                    <span className="text-xs font-bold" style={{color:"#a5b4fc"}}>{u.total_comentarii} com.</span>
                    <span className="text-xs font-bold" style={{color:"#fde047"}}>{pct}%</span>
                  </div>
                </div>
                <div className="rounded-full h-1.5" style={{background:"rgba(255,255,255,0.06)"}}>
                  <div className="h-1.5 rounded-full" style={{width:`${Math.min(pct,100)}%`,background:"linear-gradient(135deg,#6366f1,#8b5cf6)"}}></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}


// ============================================================
// EXPORT AI — pachet ZIP cu fișiere pentru analiză Claude
// ============================================================
function IntelligenceExport({ accountId, pageId }) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(new Set());
  const [exporting, setExporting] = useState(false);
  const [daysBack, setDaysBack] = useState(90);
  const [minComments, setMinComments] = useState(50);
  const [includeBlocked, setIncludeBlocked] = useState(true);
  const [includeWhitelist, setIncludeWhitelist] = useState(false);

  // Listez postările exportabile
  const fetchPosts = () => {
    setLoading(true);
    const params = new URLSearchParams();
    if (pageId) params.append("page_id", pageId);
    if (accountId) params.append("account_id", accountId);
    params.append("days_back", daysBack);
    params.append("min_comments", minComments);
    
    axios.get(`${API}/intelligence/exportable-posts?${params}`)
      .then(res => setPosts(res.data || []))
      .catch(err => {
        console.error(err);
        alert("Eroare la încărcarea postărilor");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchPosts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountId, pageId, daysBack, minComments]);

  const toggleSelect = (postId) => {
    const newSet = new Set(selected);
    if (newSet.has(postId)) newSet.delete(postId);
    else newSet.add(postId);
    setSelected(newSet);
  };

  const selectAll = () => {
    if (selected.size === posts.length) {
      setSelected(new Set());
    } else {
      setSelected(new Set(posts.map(p => p.id)));
    }
  };

  const doExport = async () => {
    if (selected.size === 0) {
      alert("Selectează cel puțin o postare");
      return;
    }
    if (selected.size > 10) {
      alert("Maxim 10 postări per export");
      return;
    }

    setExporting(true);
    try {
      const response = await axios.post(
        `${API}/intelligence/export`,
        {
          post_ids: Array.from(selected),
          include_blocked: includeBlocked,
          include_whitelist: includeWhitelist
        },
        { responseType: 'blob' }
      );

      // Extrag numele fișierului din header
      let filename = `analiza_intelligence_${Date.now()}.zip`;
      const cd = response.headers['content-disposition'];
      if (cd) {
        const m = cd.match(/filename="(.+?)"/);
        if (m) filename = m[1];
      }

      // Trigger download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      // Reset selecție după export
      setSelected(new Set());
    } catch (err) {
      console.error(err);
      alert("Eroare la export: " + (err.response?.data?.detail || err.message));
    } finally {
      setExporting(false);
    }
  };

  const fmtDate = (s) => {
    if (!s) return "";
    try {
      const d = new Date(s + (s.endsWith('Z') ? '' : 'Z'));
      return d.toLocaleString('ro-RO', { day:'2-digit', month:'short', hour:'2-digit', minute:'2-digit' });
    } catch { return s; }
  };

  return (
    <div className="space-y-4">
      {/* Header informativ */}
      <div className="rounded-xl p-4" style={{background:"rgba(99,102,241,0.08)", border:"1px solid rgba(99,102,241,0.2)"}}>
        <h3 className="text-base font-bold text-white mb-2">📥 Export pentru analiză AI</h3>
        <p className="text-sm" style={{color:"rgba(255,255,255,0.65)"}}>
          Selectează una sau mai multe postări și apasă <strong>Exportă</strong>. Vei primi un ZIP cu fișierele 
          de analiză (.txt + .csv + baseline + instrucțiuni pentru Claude). Pentru 2+ postări, instrucțiunile 
          cer automat și analiză comparativă.
        </p>
      </div>

      {/* Filtre */}
      <div className="rounded-xl p-4" style={card}>
        <div className="flex gap-4 flex-wrap items-end">
          <div>
            <label className="text-xs block mb-1" style={{color:"rgba(255,255,255,0.5)"}}>Perioadă (zile în urmă)</label>
            <select value={daysBack} onChange={e => setDaysBack(parseInt(e.target.value))}
              className="px-3 py-2 rounded-lg text-sm" 
              style={{background:"rgba(255,255,255,0.04)", color:"white", border:"1px solid rgba(255,255,255,0.1)"}}>
              <option value={7}>Ultimele 7 zile</option>
              <option value={30}>Ultimele 30 zile</option>
              <option value={90}>Ultimele 90 zile</option>
              <option value={180}>Ultimele 180 zile</option>
              <option value={365}>Ultimul an</option>
            </select>
          </div>
          <div>
            <label className="text-xs block mb-1" style={{color:"rgba(255,255,255,0.5)"}}>Min. comentarii/postare</label>
            <select value={minComments} onChange={e => setMinComments(parseInt(e.target.value))}
              className="px-3 py-2 rounded-lg text-sm"
              style={{background:"rgba(255,255,255,0.04)", color:"white", border:"1px solid rgba(255,255,255,0.1)"}}>
              <option value={10}>Min 10</option>
              <option value={20}>Min 20</option>
              <option value={50}>Min 50</option>
              <option value={100}>Min 100</option>
              <option value={200}>Min 200</option>
            </select>
          </div>
          <div className="flex gap-3 items-center">
            <label className="flex items-center gap-2 text-sm cursor-pointer" style={{color:"rgba(255,255,255,0.7)"}}>
              <input type="checkbox" checked={includeBlocked} onChange={e => setIncludeBlocked(e.target.checked)} />
              Include blocați
            </label>
            <label className="flex items-center gap-2 text-sm cursor-pointer" style={{color:"rgba(255,255,255,0.7)"}}>
              <input type="checkbox" checked={includeWhitelist} onChange={e => setIncludeWhitelist(e.target.checked)} />
              Include whitelist
            </label>
          </div>
        </div>
      </div>

      {/* Acțiuni */}
      <div className="flex justify-between items-center flex-wrap gap-3">
        <div className="flex gap-2 items-center">
          <button onClick={selectAll} className="px-3 py-1.5 rounded-lg text-xs" style={btnGray}>
            {selected.size === posts.length && posts.length > 0 ? "Deselectează tot" : "Selectează tot"}
          </button>
          <span className="text-sm" style={{color:"rgba(255,255,255,0.5)"}}>
            {selected.size} / {posts.length} selectate
          </span>
        </div>
        <button onClick={doExport} disabled={exporting || selected.size === 0}
          className="px-5 py-2 rounded-xl text-sm font-bold transition-all disabled:opacity-50"
          style={selected.size > 0 ? btnPrimary : btnGray}>
          {exporting ? "⏳ Se exportă..." : `📥 Exportă ${selected.size > 0 ? `(${selected.size} ${selected.size === 1 ? "postare" : "postări"})` : ""}`}
        </button>
      </div>

      {/* Lista postări */}
      <div className="rounded-xl" style={card}>
        {loading ? (
          <div className="p-8 text-center" style={{color:"rgba(255,255,255,0.4)"}}>Se încarcă...</div>
        ) : posts.length === 0 ? (
          <div className="p-8 text-center" style={{color:"rgba(255,255,255,0.4)"}}>
            Nicio postare cu cel puțin {minComments} comentarii în ultimele {daysBack} zile
          </div>
        ) : (
          <div className="divide-y" style={{borderColor:"rgba(255,255,255,0.05)"}}>
            {posts.map(p => {
              const isSelected = selected.has(p.id);
              const negPct = p.nr_comm > 0 ? Math.round(100 * p.nr_neg / p.nr_comm) : 0;
              const blockPct = p.nr_comm > 0 ? Math.round(100 * p.nr_blocati / p.nr_comm) : 0;
              return (
                <div key={p.id} onClick={() => toggleSelect(p.id)}
                  className="p-3 cursor-pointer transition-all hover:bg-white/5"
                  style={{background: isSelected ? "rgba(99,102,241,0.1)" : "transparent"}}>
                  <div className="flex items-start gap-3">
                    <input type="checkbox" checked={isSelected} onChange={() => {}} className="mt-1" />
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center justify-between gap-2 mb-1">
                        <span className="text-xs font-bold" style={{color:"#a5b4fc"}}>{p.page_name}</span>
                        <span className="text-xs" style={{color:"rgba(255,255,255,0.4)"}}>{fmtDate(p.created_time)}</span>
                      </div>
                      <p className="text-sm text-white mb-2 line-clamp-2">{p.preview || "(fără text)"}</p>
                      <div className="flex gap-4 text-xs flex-wrap">
                        <span style={{color:"rgba(255,255,255,0.6)"}}>💬 <strong>{p.nr_comm}</strong> comentarii</span>
                        <span style={{color:"#fca5a5"}}>⚠️ <strong>{p.nr_neg}</strong> negative ({negPct}%)</span>
                        <span style={{color:"#fdba74"}}>🚫 <strong>{p.nr_blocati}</strong> blocați ({blockPct}%)</span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
